import axios from "axios";
import {
  CHANGE_DELIVERY_OPTION_BODY,
  FETCH__LOCATION_IN_BASKET,
  SHOW_CATALOGUS,
  SHOW_HOOFDGROEP,
  SHOW_SUBGROEP,
  STORE_URL,
  UPDATE_FARMER,
  UPDATE_GROUP,
  UPDATE_HOOFDGROUP,
  UPDATE_LOCATION,
  UPDATE_PRODUCTS,
  UPDATE_SEARCHTERM,
  UPDATE_SUBGROUP,
  UPDATE_SUBPRODUCTS,
  UPDATE_SUPPLIER,
  USED_SEARCH_TERM,
} from "./actionTypes";

export const changeLocation = (currentLocation) => (dispatch) => {
  dispatch({ type: UPDATE_LOCATION, payload: currentLocation });
};

export const changeSupplier = (currentSupplier) => (dispatch) => {
  dispatch({ type: UPDATE_SUPPLIER, payload: currentSupplier });
};

export const changeProductgroup = (currentProductgroup) => (dispatch) => {
  dispatch({ type: UPDATE_GROUP, payload: currentProductgroup });
};

export const changeFarmer = (currentFarmer) => (dispatch) => {
  dispatch({ type: UPDATE_FARMER, payload: currentFarmer });
};

export const changeHoofdgroep = (currentHoofdgroup) => (dispatch) => {
  dispatch({ type: UPDATE_HOOFDGROUP, payload: currentHoofdgroup });
};

export const changeSubgroep = (currentSubgroup) => (dispatch) => {
  dispatch({ type: UPDATE_SUBGROUP, payload: currentSubgroup });
};

export const changeUsedSearchTerm = (boolean) => (dispatch) => {
  dispatch({ type: USED_SEARCH_TERM, payload: boolean });
};

export const changeSubproducts = (currentSubproducts) => (dispatch) => {
  dispatch({ type: UPDATE_SUBPRODUCTS, payload: currentSubproducts });
};

export const changeProducts = (products) => (dispatch) => {
  dispatch({ type: UPDATE_PRODUCTS, payload: products });
};

export const changeSearchTerm = (searchTerm) => (dispatch) => {
  dispatch({ type: UPDATE_SEARCHTERM, payload: searchTerm });
};

export const storeUrl = (url) => (dispatch) => {
  dispatch({ type: STORE_URL, payload: url });
};

export const setShowHoofdgroep = (true_or_false) => (dispatch) => {
  dispatch({ type: SHOW_HOOFDGROEP, payload: true_or_false });
};

export const setShowSubgroep = (true_or_false) => (dispatch) => {
  dispatch({ type: SHOW_SUBGROEP, payload: true_or_false });
};

export const setShowCatalogus = (true_or_false) => (dispatch) => {
  dispatch({ type: SHOW_CATALOGUS, payload: true_or_false });
};

export const changeDeliveryOptionBody = (body) => (dispatch) => {
  dispatch({ type: CHANGE_DELIVERY_OPTION_BODY, payload: body });
};

export const fetchLocationsInBasket = (userId) => (dispatch) => {
  const requestData = {
    user_id: userId,
  };

  return axios
    .post("/locations_in_basket", requestData)
    .then((response) => {
      return dispatch({
        type: FETCH__LOCATION_IN_BASKET,
        payload: response.data.data.locations,
      });
    })
    .catch((err) => {
      console.log(
        "[Assortiment.actions.js] fetchSuppliers|| Could not fetch locations that were in a basket. Try again later."
      );
    });
};
